/* eslint-disable react/prop-types */
import { Link, useLocation } from 'react-router-dom';
import clsx from 'clsx';
import {
  BarChart3,
  CalendarDays,
  FileSignature,
  FileText,
  FolderOpen,
  LayoutDashboard,
  Lock,
  Receipt,
  Users,
} from 'lucide-react';
import { Container } from '@/components/container';

/**
 * The staff app's features, shown greyed out. These are fixed labels: no
 * route, no API call and nothing rendered behind them. Clicking one only opens
 * the "part of OAK Legal" panel.
 */
const OAK_FEATURES = [
  { title: 'Dashboard', icon: LayoutDashboard },
  { title: 'Contacts', icon: Users },
  { title: 'Calendar', icon: CalendarDays },
  { title: 'Billing', icon: Receipt },
  { title: 'Documents', icon: FileText },
  { title: 'E-Signatures', icon: FileSignature },
  { title: 'Reports', icon: BarChart3 },
];

// The same underline treatment as the staff mega menu.
const itemClass =
  'flex items-center gap-1.5 whitespace-nowrap py-3.5 border-b-2 border-transparent text-sm font-medium';

const PortalNavbar = ({ showOakFeatures, onOakFeature }) => {
  const { pathname } = useLocation();
  // The list and every matter page, but not Account.
  const onMatters = pathname === '/portal' || pathname.startsWith('/portal/matters');

  return (
    <div className="bg-[--tw-navbar-bg] dark:bg-[--tw-navbar-bg-dark] border-y border-gray-300 dark:border-light mb-5 lg:mb-10">
      <Container className="flex items-stretch gap-6 overflow-x-auto">
        <Link
          to="/portal"
          className={clsx(itemClass, onMatters ? 'border-b-gray-800 text-gray-900' : 'text-gray-800 hover:text-gray-900')}
        >
          <FolderOpen size={15} />
          My Matters
        </Link>

        {showOakFeatures &&
          OAK_FEATURES.map(({ title, icon: Icon }) => (
            <button
              key={title}
              type="button"
              onClick={() => onOakFeature(title)}
              className={clsx(itemClass, 'text-gray-400 hover:text-gray-500 cursor-pointer')}
              title={`${title} is part of OAK Legal`}
            >
              <Icon size={15} />
              {title}
              <Lock size={11} className="opacity-70" />
            </button>
          ))}
      </Container>
    </div>
  );
};

export { PortalNavbar };
